import RRProductInnerElement from './richRelevanceInnerElement';

/** Rich relevance product item component */
/** @param {HTMLElement} element */
class RRProductItem {
  constructor(element) {
    let innerElement;
    const sameHeightElementsSelectors = [
      '.productTitle',
      '.to-print',
      '.availability',
      '.reevoo-placeholder'
    ];

    this.element = element;
    this.innerComponents = [];

    for (let i = 0, len = sameHeightElementsSelectors.length; i < len; i++) {
      innerElement = this.element.querySelector(sameHeightElementsSelectors[i]);
      if (innerElement) {
        this.innerComponents.push(new RRProductInnerElement(innerElement));
      }
    }
  }

  /**
     * Returns self as HTML element
     * @returns {element}
     */
  getElement() {
    return this.element;
  }

  /**
     * Gets the id of the product
     * @returns {string}
     */
  getId() {
    return this.element.id;
  }

  /**
     * Gets the width of the product
     * @returns {int}
     */
  getWidth() {
    return this.element.offsetWidth;
  }

  /**
     * Gets the height of the product
     * @returns {int}
     */
  getHeight() {
    this.setHeight('auto');
    return this.element.offsetHeight;
  }

  /**
     * Sets the height of product
     * @param {int|string} height
     */
  setHeight(height) {
    this.element.style.height = height + (typeof height === 'string' ? '' : 'px');
  }

  /**
     * Gets the inner components
     * @returns {Array}
     */
  getInnerComponents() {
    return this.innerComponents;
  }
}

export default RRProductItem;
